<template>
    <div class="ku-dre">
        <div class="ku-dre-top">
            <div class="s1" :class="{'active': type === 1}" @click="onClick(1)">
                <span>{{ info.dre_1 }}人</span>
                <label>粉丝</label>
            </div>

            <div class="s1" :class="{'active': type === 2}" @click="onClick(2)">
                <span>{{ info.dre_2 }}人</span>
                <label>间接粉丝</label>
            </div>

            <div class="s1" :class="{'active': type === 3}" @click="onClick(3)">
                <span>{{ info.dre_money }}元</span>
                <label>当前</label>
            </div>

            <div class="s1" :class="{'active': type === 4}" @click="onClick(4)">
                <span>{{ info.dre_money_yesterday }}元</span>
                <label>昨日</label>
            </div>

            <div class="s2" @click="onClick(0)">
                <span>分享海报</span>
            </div>
        </div>

        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            v-if="type !== 0"
        >
            <div v-for="(item, index) in list" :key="index" class="ku-dre-list">
                <span>{{item.nickname}}</span>
                <span>{{item.money}}</span>
                <span>{{item.create_time}}</span>
            </div>
        </van-list>

        <div class="ku-dre-share-s1" v-if="type === 0 && info.share_activity.status <= 1 && info.share_activity.status >= 0" @click="onShareActivity">
            <span>粉丝满{{info.share_activity.num || 50}}人（不含间接粉丝），即可获得</span>
            <label>整只潮汕卤猪手（1KG左右）</label>
        </div>

        <div class="ku-dre-share-s1 ku-dre-share-s2" v-if="type === 0 && info.share_activity.status > 1">
            <span>已领取 {{info.share_activity.time}}</span>
        </div>

        <div class="ku-dre-share" v-if="type === 0">
            <div class="ku-dre-share-tit">推荐好友，获得更多佣金</div>
            <div class="ku-dre-share-tits">长按转发分享即可</div>
        </div>

        <div class="share" v-show="type === 0">
            <van-image class="share-image" v-for="(v, k) in share" :key="k" :src="v" />
        </div>

        <van-popup closeable v-model="couponPopup" class="coupon">
            <div class="t2">
                <template v-for="(v, k) in coupon">
                    <div class="c1" :key="k" v-if="v.status === 0">
                        <div class="p1" :class="{'status-0': v.status === 0}">
                            <span>￥</span>
                            <label>{{ v.money }}</label>
                            <van-button type="primary" @click="shareWx(v.id)">分享激活</van-button>
                            <div class="span-3" v-if="v.min_money > 0">满{{v.min_money}}元可用</div>
                        </div>
                    </div>
                </template>
            </div>
        </van-popup>

        <van-overlay :show="shareOverlay" @click="shareOverlay = false">
            <van-image class="share-image" :src="require('@/assets/guide2.png')" />
        </van-overlay>

    </div>
</template>

<script>
import Vue from 'vue';
import {List, Overlay, Button, Popup, Image as VanImage, Dialog, Notify} from 'vant';
import wxApi from "@/utils/wxapi";

Vue.use(List).use(Overlay).use(Button).use(Popup).use(VanImage);

export default {
    data() {
        return {
            type: 0,
            info: {
                dre_1: 0,
                dre_2: 0,
                dre_money: 0,
                dre_money_yesterday: 0,
                share_activity: {
                    status: -1,
                    num: 50,
                    time: ''
                }
            },

            list: [],
            page: 1,
            loading: false,
            finished: false,

            couponPopup: false,
            coupon: [],

            // 分享参数
            share_title: '',
            share_desc: '',
            share_image: '',
            shareOverlay: false,
            dre_code: '',

            // 分享图片
            share_show: 0,
            share: [],
        };
    },
    mounted() {
        let that = this
        this.$API.getDreCount().then(res => {
            return res.data
        }).then(res => {
            this.info = res.data
        });

        // 获取用户余额
        that.$API.getUserMoney().then(res => {
            that.money = res.data.data.money
            res.data.data.coupon.forEach(v => {
                if (v.status === 0) {
                    that.coupon.push(v)
                }
            })
            that.dre_code = res.data.data.dre_code
            that.recharge_list = res.data.data.recharge

            that.getSite();
        })
        that.$API.getUserShare().then(res => {
            return res.data
        }).then(res => {
            that.share = res.data
        })
    },
    methods: {
        onClick(type) {
            this.type = type
            this.list = []
            this.page = 1
            if (type === 9) {
                this.share_show = 1
            } else {
                this.share_show = 0
                this.finished = false
            }
        },
        onLoad() {
            // 异步更新数据
            let that = this;
            that.$API.getDre({type: that.type, page: that.page}).then(res => {
                return res.data
            }).then(res => {
                if (res.data.length > 0) {
                    res.data.forEach(vo => {
                        that.list.push(vo);
                    })
                } else {
                    this.finished = true;
                }
                that.page += 1;

                // 加载状态结束
                this.loading = false;
            })

        },
        getSite() {
            let that = this
            this.$API.commonSite().then(res => {
                return res.data;
            }).then(res => {
                that.share_title = res.data.share_title;
                that.share_desc = res.data.share_desc;
                that.share_image = res.data.share_image;
                that.shareWx(0)
            })
        },
        shareWx(id) {
            let that = this
            let url  = process.env.VUE_APP_USER_URL + '/coupon?id=' + id + '&dre_code=' + that.dre_code
            wxApi.wxRegister({
                title: that.share_title, // 分享标题
                link: url, // 分享链接
                imgUrl: that.share_image, // 分享图标
                desc: that.share_desc, // 分享描述
                success: that.shareOk(id)
            })
        },
        shareOk(id) {
            if (id > 0) {
                this.shareOverlay = false
                this.couponPopup = false
            } else {
                console.log(this.coupon)
                if (this.coupon.length > 0) {
                    this.couponPopup = false
                } else {
                    this.shareOverlay = false
                }
            }
        },
        onShareActivity() {
            let that = this
            if (that.info.share_activity.status === 1) {
                // 领取
                Dialog.confirm({
                    title: '标题',
                    message: '请确认是否已领取到猪手？',
                }).then(() => {
                    // on confirm
                    that.$API.activity_fs().then(res => {
                        return res.data;
                    }).then(() => {
                        Notify('领取成功');
                        this.$API.getDreCount().then(res => {
                            return res.data
                        }).then(res => {
                            this.info = res.data
                        });
                    })
                }).catch(() => {
                    // on cancel
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.ku-dre {
    .ku-dre-top {
        display: flex;
        background: #009C90;
        height: 100px;
        padding: 10px;
        line-height: 50px;
        justify-content: space-between;
        color: white;
        .s1 {
            width: 20%;
            span {
                font-size: 30px;
                display: block;
            }
        }
        .active {
            color: #DEF212;
        }
        .s2 {
            background: #E45A24;
            height: 60px;
            width: 100px;
            border-radius: 15px;
            font-size: 24px;
            line-height: 60px;
            margin-top: 20px;
            padding: 0 15px;
        }
    }

    .ku-dre-list {
        display: flex;
        justify-content: space-between;
        padding: 20px;
        border-bottom: 1px solid #ddd;
        margin: 3px 20px;
        font-size: 26px;
        color: #009C90;
    }

    .coupon {
        overflow: visible;
        width: 700px;
        padding: 30px 10px;
        background: #E5E5E5;
        border-radius: 20px;
        .t1 {
            height: 50px;
            display: inline-block;
            background: #EA861E;
            margin: 0 auto;
            border: 1px solid white;
            padding: 5px 20px;
            border-radius: 20px;
            span {
                display: inline-block;
                font-size: 25px;
                line-height: 50px;
                color: white;
            }
        }
        .t2 {
            width: 100%;
            margin: 20px auto;
            text-align: left;
            display: inline-block;
            .c1 {
                width: 346px;
                height: 110px;
                margin: 1px 2px;
                background: #BAA58C;
                float: left;
                line-height: 100px;
                position: relative;
                color: #ffffff;
                .p1 {
                    & > span {
                        font-size: 24px;
                        line-height: 24px;
                        position: absolute;
                        left: 10px;
                        top: 10px;

                    }

                    label {
                        font-size: 85px;
                        position: absolute;
                        left: 30px;
                    }

                    .van-button {
                        width: 150px;
                        height: 50px;
                        line-height: 50px;
                        text-align: center;
                        position: absolute;
                        right: 20px;
                        top: 22px;
                        border-radius: 10px;
                        border-color: #fff;
                        background: #009C90;
                        padding: 0 2px;
                    }
                    &.status-0 {
                        color: #806239;
                    }
                    .span-3 {
                        width: 150px;
                        height: 24px;
                        position: absolute;
                        left: 10px;
                        top: 85px;
                        line-height: 24px;
                        z-index: 1;
                        text-align: center;
                        font-size: 20px;
                        color: white;
                    }
                }
            }
        }
        /deep/ .van-popup__close-icon--top-right {
            top: -15px;
            right: -15px;
            width: 50px;
            height: 50px;
            color: white;
            text-align: center;
            line-height: 50px;
            background: red;
            border-radius: 50px;
        }
    }

    .ku-dre-share {
        font-size: 30px;
        margin-top: 30px;
        color: #ed891e;
        line-height: 50px;
    }
    .share {
        .van-image {
            width: 70%;
            margin: 20px auto;
        }
    }
    .ku-dre-share-s1 {
        width: 85%;
        height: 100px;
        line-height: 50px;
        margin: 30px auto;
        display: flex;
        flex-direction: column;
        background: #E45A24;
        font-size: 30px;
        border-radius: 15px;
        color: white;
        label {
            color: #ffff00;
        }
    }
    .ku-dre-share-s2 {
        background: #BAA58C;
        line-height: 100px;
        font-size: 40px;
    }
}
</style>
